import { render, staticRenderFns } from "./figments-management-table.vue?vue&type=template&id=0ff1bb20&scoped=true&"
import script from "./figments-management-table.vue?vue&type=script&lang=js&"
export * from "./figments-management-table.vue?vue&type=script&lang=js&"
import style0 from "./figments-management-table.vue?vue&type=style&index=0&id=0ff1bb20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1bb20",
  null
  
)

export default component.exports